<template>
  <div id="footer">
    <div class="footer-content align-center">
      <p>You gotta get in touch with us! Let's make some really great stuff.</p>
      <contact-button></contact-button>
    </div>
    <div class="footer-footer">
      <div class="left-side">
        <social-icons
          :scale=1.5
          :twitter="studio308.links.twitter"
          :github="studio308.links.github"
          :instagram="studio308.links.instagram"
          :linkedin="studio308.links.linkedin"
          :google-plus="studio308.links.google_plus"
          :facebook="studio308.links.facebook"
        ></social-icons>
      </div>
      <div class="right-side">
        <copyright></copyright>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import DataStore from '@/storage/data'
import ContactButton from '@/components/ContactButton'
import Copyright from '@/components/Copyright'
import SocialIcons from '@/components/SocialIcons'
export default {
  name: 'page-footer',
  data () {
    return {
      studio308: DataStore.studio308
    }
  },
  components: {
    ContactButton,
    Copyright,
    SocialIcons
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss

  #footer
    background-color: $darkGrey
    padding: 75px 15% 50px
    color: $grey

    > .footer-footer
      margin-top: 25px
      padding-top: 25px
      border-top: 2px solid $grey

      > .left-side
        text-align: center
        margin-bottom: 15px

        @media screen and (min-width: $break-small)
          margin-bottom: 0
          float: left

      > .right-side
        text-align: center

        @media screen and (min-width: $break-small)
          float: right
  
</style>



// WEBPACK FOOTER //
// PageFooter.vue?069875fc